import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

/**
 * @param {string}  orderNo
 */
function useDetail(orderNo) {
  const { cb, key } = fetch(orderNo);

  const { data, isSuccess, isLoading } = useQuery(key, cb);

  return { data, isSuccess, isLoading };
}

export default {
  useDetail,
};
